<template>
  <div class="formation-view">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1>🎓 Formations Professionnelles</h1>
          <p>Développez vos compétences avec nos formations spécialisées</p>
          <div class="hero-features">
            <div class="feature-item">
              <span class="feature-icon">💼</span>
              <span>Professionnel</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">📈</span>
              <span>Pratique</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">🎯</span>
              <span>Personnalisé</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">🏆</span>
              <span>Certifiant</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Main Content -->
    <section class="main-content">
      <div class="container">
        <div class="content-intro">
          <h2>Nos Programmes de Formation</h2>
          <p>Acquérez les compétences essentielles pour exceller dans votre carrière professionnelle</p>
        </div>

        <!-- Formation Categories -->
        <div class="formation-categories">
          <h3>Domaines de Formation</h3>

          <!-- Bureautique -->
          <div class="formation-category">
            <div class="category-header">
              <h4>💻 Bureautique & Pack Office</h4>
              <p>Maîtrisez les outils bureautiques essentiels</p>
            </div>
            <div class="category-courses">
              <div class="course-card">
                <h5>Microsoft Word - Maîtrise</h5>
                <p>Traitement de texte avancé, mise en page, modèles professionnels</p>
                <div class="course-meta">
                  <span class="level">Niveau : Débutant à Intermédiaire</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Excel - Tableaux & Analyses</h5>
                <p>Formules, graphiques, tableaux croisés dynamiques, macros</p>
                <div class="course-meta">
                  <span class="level">Niveau : Tous niveaux</span>
                </div>
              </div>
              <div class="course-card">
                <h5>PowerPoint - Présentations</h5>
                <p>Création de présentations impactantes, animations, multimédia</p>
                <div class="course-meta">
                  <span class="level">Niveau : Tous niveaux</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Pack Office Complet</h5>
                <p>Formation intégrale Word + Excel + PowerPoint + Outlook</p>
                <div class="course-meta">
                  <span class="level">Niveau : Débutant</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Comptabilité -->
          <div class="formation-category">
            <div class="category-header">
              <h4>📊 Logiciels Comptables</h4>
              <p>Spécialisation en gestion comptable et fiscale</p>
            </div>
            <div class="category-courses">
              <div class="course-card">
                <h5>Logiciels de Caisse</h5>
                <p>Gestion des encaissements, clôture caisse, rapports financiers</p>
                <div class="course-meta">
                  <span class="level">Niveau : Intermédiaire</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Comptabilité Immobilisations</h5>
                <p>Gestion des actifs, amortissements, cessions d'immobilisations</p>
                <div class="course-meta">
                  <span class="level">Niveau : Avancé</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Système e-Impôt</h5>
                <p>Déclarations fiscales en ligne, conformité, optimisation fiscale</p>
                <div class="course-meta">
                  <span class="level">Niveau : Tous niveaux</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Comptabilité Intégrale</h5>
                <p>Formation complète comptabilité générale + logiciels spécialisés</p>
                <div class="course-meta">
                  <span class="level">Niveau : Débutant à Avancé</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Informatique -->
          <div class="formation-category">
            <div class="category-header">
              <h4>🖥️ Informatique & Digital</h4>
              <p>Compétences numériques essentielles</p>
            </div>
            <div class="category-courses">
              <div class="course-card">
                <h5>Internet & Navigation Web</h5>
                <p>Recherche efficace, sécurité en ligne, outils web professionnels</p>
                <div class="course-meta">
                  <span class="level">Niveau : Débutant</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Transformation Digitale</h5>
                <p>Outils collaboratifs, gestion de projet, méthodologies agiles</p>
                <div class="course-meta">
                  <span class="level">Niveau : Intermédiaire</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Cybersécurité</h5>
                <p>Protection des données, bonnes pratiques, sensibilisation sécurité</p>
                <div class="course-meta">
                  <span class="level">Niveau : Tous niveaux</span>
                </div>
              </div>
              <div class="course-card">
                <h5>Informatique de Base</h5>
                <p>Prise en main PC, système d'exploitation, maintenance</p>
                <div class="course-meta">
                  <span class="level">Niveau : Débutant</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Formation Process -->
        <div class="formation-process">
          <h3>Notre Méthodologie Pédagogique</h3>
          <div class="process-steps">
            <div class="process-step">
              <div class="step-number">1</div>
              <h4>Évaluation</h4>
              <p>Analyse de vos besoins et niveau actuel</p>
            </div>
            <div class="process-step">
              <div class="step-number">2</div>
              <h4>Programme personnalisé</h4>
              <p>Adaptation du contenu à vos objectifs</p>
            </div>
            <div class="process-step">
              <div class="step-number">3</div>
              <h4>Formation pratique</h4>
              <p>Apprentissage par la pratique et exercices</p>
            </div>
            <div class="process-step">
              <div class="step-number">4</div>
              <h4>Certification</h4>
              <p>Attestation de compétences acquises</p>
            </div>
          </div>
        </div>

        <!-- Contact CTA -->
        <div class="formation-cta">
          <h3>Prêt à développer vos compétences ?</h3>
          <p>Contactez-nous pour un devis personnalisé selon vos besoins</p>
          <div class="cta-buttons">
            <router-link to="/contacts" class="btn-primary">Demander un devis</router-link>
            <router-link to="/about" class="btn-secondary">En savoir plus</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'FormationView'
}
</script>

<style scoped>
.formation-view {
  padding-top: 70px;
  min-height: 100vh;
}

/* ===== HERO SECTION ===== */
.hero-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%), url('@/assets/techartisan.jpg') center/cover;
  color: white;
  padding: 6rem 0 4rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.8) 50%, rgba(66, 185, 131, 0.7) 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.hero-section h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #ffffff, #e0e7ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-section p {
  font-size: 1.3rem;
  margin-bottom: 3rem;
  opacity: 0.9;
}

.hero-features {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 1rem 1.5rem;
  border-radius: 50px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
}

.feature-icon {
  font-size: 1.5rem;
}

/* ===== MAIN CONTENT ===== */
.main-content {
  padding: 5rem 0;
  background: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.content-intro {
  text-align: center;
  margin-bottom: 4rem;
}

.content-intro h2 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-weight: 700;
}

.content-intro p {
  font-size: 1.2rem;
  color: #666;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ===== FORMATION CATEGORIES ===== */
.formation-categories h3 {
  font-size: 2rem;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 600;
}

.formation-category {
  background: white;
  border-radius: 16px;
  padding: 3rem;
  margin-bottom: 3rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.category-header {
  text-align: center;
  margin-bottom: 3rem;
}

.category-header h4 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-weight: 600;
}

.category-header p {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
}

.category-courses {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.course-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.course-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.course-card h5 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.course-card p {
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.6;
  font-size: 0.95rem;
}

.course-meta {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.level {
  font-size: 0.85rem;
  color: #42b983;
  font-weight: 500;
}

/* ===== FORMATION PROCESS ===== */
.formation-process {
  background: white;
  border-radius: 16px;
  padding: 3rem;
  margin: 4rem 0;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.formation-process h3 {
  font-size: 2rem;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 600;
}

.process-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.process-step {
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
}

.process-step::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #42b983, #667eea);
  border-radius: 2px;
}

.step-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #42b983, #667eea);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 auto 1.5rem;
  box-shadow: 0 4px 15px rgba(66, 185, 131, 0.3);
}

.process-step h4 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.25rem;
  font-weight: 600;
}

.process-step p {
  color: #666;
  line-height: 1.6;
}

/* ===== CTA SECTION ===== */
.formation-cta {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4rem 2rem;
  border-radius: 16px;
  text-align: center;
  margin-top: 4rem;
}

.formation-cta h3 {
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.formation-cta p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
  .hero-section {
    padding: 4rem 0 3rem;
  }

  .hero-section h1 {
    font-size: 2.2rem;
  }

  .hero-features {
    gap: 1rem;
  }

  .feature-item {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }

  .content-intro h2 {
    font-size: 2rem;
  }

  .formation-category {
    padding: 2rem;
  }

  .category-courses {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .course-card {
    padding: 1.5rem;
  }

  .process-steps {
    grid-template-columns: 1fr;
  }

  .formation-cta {
    padding: 3rem 1.5rem;
  }

  .formation-cta h3 {
    font-size: 1.8rem;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .hero-section h1 {
    font-size: 1.8rem;
  }

  .formation-category {
    padding: 1.5rem;
  }

  .course-card {
    padding: 1.25rem;
  }

  .course-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
</style>
